import type { ReactNode } from 'react';

export function FormErrorSummary({
  message,
  children,
}: {
  message?: string | undefined;
  children?: ReactNode;
}) {
  if (!message && !children) return null;
  return (
    <div className="auth-error-summary" role="alert">
      <i className="pi pi-exclamation-circle" aria-hidden="true" />
      <div>
        <strong>We could not complete that request.</strong>
        {message && <p>{message}</p>}
        {children}
      </div>
    </div>
  );
}
